import { Flex, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface NumberedStepProps {
  number: number;
  children: ReactNode;
}

export const NumberedStep: React.FC<NumberedStepProps> = ({
  number,
  children,
}) => {
  return (
    <Flex
      align="flex-start"
      gap={3}
      py={2}
    >
      <Flex
        align="center"
        justify="center"
        w="24px"
        h="24px"
        minW="24px"
        borderRadius="full"
        bg="green.500"
        color="white"
        fontSize="sm"
        fontWeight="bold"
      >
        {number}
      </Flex>
      <Text fontSize="sm" color="gray.800" lineHeight="1.6" pt="2px">
        {children}
      </Text>
    </Flex>
  );
};
